import HTTP from '@/plugins/axios';
import { ICourseResponse } from '@/types/courses/Courses';

export async function fetchCoursesList<Type extends Record<string, unknown>>(params: Type) {
  try {
    const res = await HTTP.get('/jobchance/course_list', { params });
    return res.data as ICourseResponse;
  } catch (error: any) {
    console.log(error.message);
    throw error;
  }
}
export async function getCoursesList(params: any) {
  try {
    const res = await HTTP.get('/course/list', { params });
    return res.data as any;
  } catch (error: any) {
    console.log(error.message);
    throw error;
  }
}
